import { DataTable } from "@/components/data-table";
import { usersColumns } from "@/features/users/components/users-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useUsersList } from "@/features/users/hooks/useUsersList";
import SearchInput from "@/components/search-input";
import ListContent from "@/features/users/components/list-content";
import { useUsersFilterStore } from "@/features/users/stores";
import UsersFilterComponent from "@/features/users/components/filter-component";
import { ROUTES } from "@/constants/routes";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { selectedRowsAtom } from "@/stores/atoms/selected-rows-atom";
import { useEffect } from "react";

const UsersListPage = () => {
  const { t } = useTranslation();
  const [rowSelection, setRowSelection] = useAtom(selectedRowsAtom);
  const { users, page, pageCount, setPage, isLoading, isFetching } =
    useUsersList();
  const { searchValue, setSearchValue } = useUsersFilterStore();

  useEffect(() => {
    return () => setSearchValue(null);
  }, [setSearchValue]);

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="flex items-center gap-2 lg:hidden px-3 sm:px-6">
        <SearchInput value={searchValue ?? ""} onChange={setSearchValue} />
        <UsersFilterComponent />
      </div>
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={usersColumns(t)}
          data={users}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
          rowSelection={rowSelection}
          onRowSelectionChange={setRowSelection}
        />
      </div>
      <ListContent
        data={users}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
        rowSelection={rowSelection}
        onRowSelectionChange={setRowSelection}
      />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <EmptyTable
      title={t("modules.users.datatable.no_users")}
      subtitle={t("modules.users.datatable.add_user")}
      action={() => navigate(ROUTES.USER_CREATE)}
      actionTitle={t("modules.users.keys.add_user")}
    />
  );
};

export default UsersListPage;
